/* Adaptive page-title helper. Appends the brand only when the whole title stays
   within the SERP length limit (~63 chars), so long compound peptide names don't
   get truncated in search results. Keep titles ≤ 65 chars (Ubersuggest / Google).
   Longer cores drop the brand rather than overflow. */
const BRAND = 'CalculateMyPeptides'
const MAX = 60

export function withBrand(core, max = MAX) {
  const full = `${core} | ${BRAND}`
  return full.length <= max ? full : core
}
